<template>
  <bim-text
    class="text-valid text-valid--spec"
    type="main"
  >
    <slot />
  </bim-text>
</template>

<script>
import bimText from '@/components/text/bimText/bimText'
export default {
  name: 'TextValid',
  components: {
    bimText
  }
}
</script>

<style lang="scss" scoped>
.text-valid.text-valid--spec {
  font-size: 0.9667rem;
  font-weight: 600;
  line-height: 1.77;
  letter-spacing: 0.1rem;
  color: $primary-color;
  text-align: center;
  opacity: 1;
  text-transform: uppercase;
}
</style>
